/*
Copyright (c) 2026 Wind River Systems, Inc.

The right to copy, distribute, modify, or otherwise make use of this software may be licensed only pursuant to the terms of an applicable Wind River license agreement.
*/
import { Component, OnInit, AfterViewInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ConfigService } from '@windriver/authentication';
import { environment } from '@environment';
import { map } from 'rxjs/operators';

@Component({
  selector: 'wsn-help-faq',
  templateUrl: './help-faq.component.html',
  styleUrls: ['./help-faq.component.scss']
})
export class HelpFaqComponent implements OnInit, AfterViewInit {
  private anchor: string;
  private route: ActivatedRoute;
  public minioUrl: string;

  // Provide configuration of URLs in otherwise static HTML content
  readonly documentationUrl = environment.documentationUrl;
  readonly supportUrl = environment.supportUrl;
  readonly licensingUrl = environment.licensingUrl;
  readonly esdSupportUrl = environment.esdSupportUrl;
  readonly wrLinuxMirrorCreation = environment.wrLinuxMirrorCreation;
  readonly cgitUrl = environment.cgitUrl;

  constructor(route: ActivatedRoute, private configService: ConfigService) {
    route.data.pipe(map((d) => d['anchor'])).subscribe((anchor) => {
      this.route = route;
      this.anchor = anchor;
    });
  }

  ngOnInit(): void {
    this.configService.configState.subscribe((config: any) => {
      if (config) {
        this.minioUrl = config.minioUrl;
      }
    });
    this.scrollTo(this.anchor);
  }

  ngAfterViewInit(): void {
    if (this.route.fragment) {
      this.scrollTo(this.route.snapshot.fragment);
    }
  }

  public scrollTo(elementId: string): void {
    if (elementId != null) {
      const element = document.getElementById(elementId);
      if (element != null) {
        element.scrollIntoView({ behavior: 'auto', block: 'start', inline: 'start' });
      }
    }
  }
}
